/* 

----- Content Refresh ----- 
Content refresh calls home after a configurable interval has been completed, then compares the the response with what was originally in a container if it is different then the content is replaced.
*/



var instances = {};

function getInstanceId(context) {
    if (!context) {
        AXISDebug.output(3,"Content Refresh: No context provided");
        return false;
    }
    let id = context.attr(expressSelectors()['content-refresh']['initialise']);
    if (!id) {
        AXISDebug.output(3,"Content Refresh: No Id found, has this element been initialised?");
        return false;
    } else {
        return id;
    }
}

// Instances get / set functions.
function setContext(id, value) {
    instances[id]['context'] = value;
    return instances[id]['context'];
}
function getContext(id) {
    return instances[id]['context'];
}
function setTimer(id, value) {
    instances[id]['timer'] = value;
    return instances[id]['timer'];
}
function getTimer(id) {
    return instances[id]['timer'];
}
function setResponseContainer(id, value) {
    instances[id]['response-container'] = value;
    return instances[id]['response-container'];
}
function getResponseContainer(id) {
    return instances[id]['response-container'];
}
function setRefreshTimer(id, value) {
    instances[id]['refresh-timer'] = value;
    return instances[id]['refresh-timer'];
}
function getRefreshTimer(id) {
    return instances[id]['refresh-timer'];
}
function setModalConfirmId(id, value) {
    return instances[id]['modal-confirm-id'] = value;
}
function getModalConfirmId(id) {
    return instances[id]['modal-confirm-id'];
}
function setIsAccordion(id, value) {
    return instances[id]['accordion'] = value;
}
function getIsAccordion(id) {
    return instances[id]['accordion'];
}

function initialiseAll() {
    // Get elements.
    let elements = $('[' + expressSelectors()['content-refresh']['initialise'] + ']');
    // If any exist.
    if (elements) {
        // Loop through each one.
        elements.each(function() {
            // Get element context.
            let context = $(this);
            // Initialise.
            let init = initialise(context);
        });
    }
}

function initialise(context) {
    // Get instance id.
    let id = context.attr(expressSelectors()['content-refresh']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['content-refresh']['initialise'], generateId());
        id = context.attr(expressSelectors()['content-refresh']['initialise']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Content Refresh: Instance already initialised skipping.");
        }
        return false;
    }
    // Get configuration values.
    let timer = context.attr(expressSelectors()['content-refresh']['timer'])
    let responseContainer = context.attr(expressSelectors()['ajax']['response-context']);
    // Is a modal confirm attached, if so take the modal id.
    const confirmModalId = context.attr(expressSelectors()['modals']['confirm']);
    // Check if is in accordion, this may need to be extended in the future to travel up the the DOM to gain context.
    const isAccordion = (context.attr(expressSelectors()['axis-responsive-tabs']['content']) != undefined);   
    // Set config.
    setContext(id, context);
    setTimer(id, timer);
    setResponseContainer(id, $('#' + responseContainer));
    setModalConfirmId(id, confirmModalId);
    setIsAccordion(id, isAccordion);
    // If an accordion allow the open pane proceedure control starting the timer.
    if (!isAccordion) {
        // Start refresh timer.
        startRefreshTimer(id);
    }
}

function startRefreshTimer(id) {
    // Get context.
    const context = getContext(id);
    // Check if we need to confirm the refresh with the user.
    const modalConfirmId = getModalConfirmId(id);
    // Check if is in accordion, this may need to be extended in the future to travel up the the DOM to gain context.
    const isAccordion = getIsAccordion(id);     
    // Get delay.
    const delay = parseInt(getTimer(id));
    let interval = setInterval(() => {
        // Check debug flag.
        let paused = (sessionStorage.getItem('content-refresh-paused') == "true");
        if (paused) {
            console.warn("Content Refresh: Skipping due to content-refresh-paused set.");
            return;
        }
        if (modalConfirmId) {
            // Get modal context.
            const modal = $('[' + expressSelectors()['modals']['modal-context'] + '="' + modalConfirmId +'"]');
            if (!modal.length) {
                AXISDebug.output(3,"Content Refresh: Could not find confirmation modal in DOM", context);
                return false;
            }
            const customConfig = {
                "modal-confirm": true,
                "context": context, // Pass in initialisation element.
                "queue-behavior": "queued"
            }
            // Check if accordion pane is active.
            if (isAccordion) {
                // Get accordion instance.
                const accordionContext = context.parents('[' + expressSelectors()['axis-responsive-tabs']['initialise'] + ']');
                if (!accordionContext.length) {
                    AXISDebug.output(3,"Content Refresh: Failed to get accordion context", context);
                    return false;
                }
                let isPaneActive = axisResponsiveTabs.isPaneActive(context);
                // If pane not active then skip, as when opened again new content would have been loaded in anyway.
                if (!isPaneActive) {
                    stopRefreshTimer(id);
                    return false;
                }
            }
            // Open modal.
            AXISModals.open(modal, customConfig);
            stopRefreshTimer(id);
            // Wait for user to confirm.
            modal.on('modal-confirmed', function() {
                modal.off('modal-confirmed');
                if (isAccordion) {
                    // Pass back the pane.
                    context.trigger('accordion-pane-refresh', [context, id]);
                } else {
                    // Else follow normal routine.
                    callback(id).catch((error) => {
                        AXISDebug.output(3,"Content Refresh: callback failed after interval completed", error);
                    });
                }
            });
            return false;
        } else {
            // Check modal(s) active.
            let isModalActive = (AXISModals.activeModals().length > 0);
            // If modal not active then get refreshed content.
            if (!isModalActive) {
                stopRefreshTimer(id);
                // Prepare + do callback.
                callback(id).then(() => {
                    startRefreshTimer(id);
                }).catch((error) => {
                    AXISDebug.output(3,"Content Refresh: callback failed after interval completed", error);
                });
            } else {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Content Refresh: Skipping callback due to modal being active");
                }
            }
        }
    }, delay);
    // Add interval to the config.
    setRefreshTimer(id, interval);
}

function stopRefreshTimer(id) {
    // Get interval.
    let interval = getRefreshTimer(id);
    clearInterval(interval);
    if (AXISDebug.level() >= 3) {
        AXISDebug.output(1,"Content Refresh: Stopped interval");
    }
    return true;
}

function callback(id) {
    return new Promise((resolve, reject) => {
        // Get context.
        let context = getContext(id);
        // Get ajax operation.
        let operation = AXISAjax.getOperation(context);
        // Get name + value pair.
        let customValue = AXISAjax.getCustomNameValuePair(context);
        // Post url.
        let url = AXISAjax.postUrl(context);
        // If no url then reload the entire page.
        if (!url) {
            if (AXISDebug.level() >= 3) {
                AXISDebug.output(2,"Content Refresh: No url provided so refreshing the entire page.");
            }
            resolve(location.reload());
        }
        // Get data type.
        let dataType = AXISAjax.getDataType(context);
        // Build data string.
        // Add custom value
        let data = customValue;
        // Add operation.
        data = (data ? data + "&" + opertation : operation );

        // Do callback.
        AXISAjax.get(url, data, dataType, context).then((data) => {
            // Get response.
            let response = data['data'];
            // Get response container.
            let container = getResponseContainer(id);
            // Check modal(s) active.
            let isModalActive = (AXISModals.activeModals().length > 0);
            // One last check before we update the DOM.
            if (!isModalActive) {
                // Place response in container.
                container.html(response);
            } else {
                if (AXISDebug.level() >= 3) {
                    AXISDebug.output(1,"Content Refresh: Skipping update as a modal is active.");
                }
            }
            resolve(container);
        }).catch((error) => {
            reject(error);
        });
    });
}

// Trigger manual refresh ( e.g. Opayo Merchant Session Key expired ).
function manualRefresh(id) {
    // Stop original timer.
    stopRefreshTimer(id);
    // Do callback.
    return callback(id);
}

var contentRefresh = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    },
    stopTimer: (id) => {
        return stopRefreshTimer(id);
    },
    startTimer: (id) => {
        return startRefreshTimer(id);
    },
    manualRefresh: (context) => {
        let id = getInstanceId(context);
        if (!id) {
            return false;
        }
        return manualRefresh(id);
    }
}

export { contentRefresh };